import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useState } from "react";
import { Menu, MenuTrigger, MenuPopover, MenuList, MenuItem, MenuDivider, MenuGroup, MenuGroupHeader, makeStyles, tokens, } from "@fluentui/react-components";
import { Button } from "./button";
const useStyles = makeStyles({
    menuPopover: {
        minWidth: "160px",
    },
    menuItem: {
        cursor: "pointer",
    },
    menuItemIcon: {
        color: tokens.colorNeutralForeground2,
    },
});
const IsDivider = (item) => {
    return "type" in item && item.type === "divider";
};
const IsGroup = (item) => {
    return "type" in item && item.type === "group";
};
const RenderMenuItem = (item, classes) => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const Icon = item.icon;
    return (_jsx(MenuItem, { className: classes.menuItem, icon: Icon ? _jsx(Icon, { className: classes.menuItemIcon }) : undefined, onClick: item.onClick, disabled: item.disabled, secondaryContent: item.secondaryContent, children: item.label }, item.key));
};
const RenderMenuItems = (items, classes) => {
    return items.map((item) => {
        if (IsDivider(item)) {
            return _jsx(MenuDivider, {}, item.key);
        }
        if (IsGroup(item)) {
            return (_jsxs(MenuGroup, { children: [item.header && _jsx(MenuGroupHeader, { children: item.header }), RenderMenuItems(item.items, classes)] }, item.key));
        }
        return RenderMenuItem(item, classes);
    });
};
/**
 * A wrapper around Fluent UI's Menu component providing a simplified API for context menus.
 * Supports menu items with icons, dividers, and grouped items.
 */
export const ContextMenu = forwardRef((props, ref) => {
    const { items, onOpenChange, disabled } = props;
    const [open, setOpen] = useState(false);
    const classes = useStyles();
    const handleOpenChange = (_, data) => {
        setOpen(data.open);
        onOpenChange?.(data.open);
    };
    return (_jsxs(Menu, { openOnContext: true, open: open, onOpenChange: handleOpenChange, children: [_jsx(MenuTrigger, { disableButtonEnhancement: true, children: props.trigger ?? (_jsx(Button, { ref: ref, icon: props.icon, onClick: (e) => {
                        e?.stopPropagation();
                        setOpen(true);
                    }, disabled: disabled })) }), _jsx(MenuPopover, { className: classes.menuPopover, children: _jsx(MenuList, { children: RenderMenuItems(items, classes) }) })] }));
});
ContextMenu.displayName = "ContextMenu";
//# sourceMappingURL=contextMenu.js.map